























































import { Component, Vue } from "vue-property-decorator";
import { classificationList, getVersion, gameType } from "@/req/homes"
@Component({
  // components: {},
})
export default class Home extends Vue {
  public active: any = null;
  public versionType = [];
  public versionList = [];
  public versionGameTypeList = [];
  public versionGameType = "all";
  public page = 1;
  public size = 20;
  public total = 0;
  public mounted() {
    if (!this.$store.state.home.versionScrollTop) {
      this.handlScroll()
    }
    this.getList();
  }
  public handlScroll() {
    window.onscroll = () => {
      this.$store.dispatch("home/authVersionScrollTop", window.pageYOffset);
    }
  }
  public versionClick(index) {
    this.active = index;
    this.$store.dispatch("home/authVersionType", index);
    this.page = 1;
    this.$store.dispatch("home/authVersionPage", 1);
    this.versionGameType = "all";
    // this.getVersion();
    this.getGameType();
  }
  public change(i) {
    this.page = i;
    this.$store.dispatch("home/authVersionScrollTop", 0);
    window.scrollTo(0, 0)
    this.$store.dispatch("home/authVersionPage", i);
    this.versionGameType = "all";
    this.getVersion();
    // this.getGameType();
  }
  public view(id) {
    this.$router.push({
      path: `/versionDetails?id=${id}`
    });
  }
  public async getList() {
    const res = await classificationList({
      token: this.$fn.cookies.getToken()
    })
    if (res.code == 200) {
      this.versionType = res.data;
      this.active = this.$store.state.home.versionType || res.data[0].id;
      this.page = this.$store.state.home.versionPage || 1;
    }
    this.getGameType();
  }
  public async getGameType() {
    const res = await gameType({
      token: this.$fn.cookies.getToken(),
      classificationId: this.active,
    })
    if (res.code == 200) {
      this.versionGameTypeList = res.data;
      this.getVersion();
    }
  }
  public changeGameType(e) {
    e == undefined ? this.versionGameType = "" : this.versionGameType = e;
    this.page = 1;
    this.getVersion();
  }
  public async getVersion() {
    const res = await getVersion({
      token: this.$fn.cookies.getToken(),
      classificationId: this.active,
      gameType: this.versionGameType == "all" ? "" : this.versionGameType,
      pageNum: this.page,
      pageSize: this.size,
    })
    if (res.code == 200) {
      this.versionList = res.data.records;
      this.total = res.data.total
      this.$nextTick(() => {
        if (this.$store.state.home.versionScrollTop) {
          window.scrollTo(0, this.$store.state.home.versionScrollTop || 0)
          this.handlScroll()
        }
      })
    }
  }
  public beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.path !== '/versionDetails') {
        vm.$store.dispatch("home/authVersionScrollTop", 0);
        vm.$store.dispatch("home/authVersionType", null);
        vm.$store.dispatch("home/authVersionPage", 1);
      }
    })
  }
  public destroyed() {
    window.onscroll = null
  }
}
